
import FormSingle from '@/components/release/form/single'

export default {
    name: 'CascadeSelector',
    components: {
        FormSingle
    },
    props: {
        value: {
            type: [String, Number, Array],
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            modelValue: []
        }
    },
    computed: {
        // 获取要显示的级联层级数据
        cascadeLevels() {
            const levels = []

            if (!this.options || this.options.length === 0) {
                return levels
            }

            // 第一级始终显示
            levels.push({
                options: this.options,
                title: this.options[0]?.propertyName
            })

            // 根据已选择的值，计算需要显示的后续级别
            let currentOptions = this.options
            const currentValue = this.modelValue || []
            for (let i = 0; i < currentValue.length; i++) {
                const selectedKey = currentValue[i]
                const selectedOption = currentOptions.find(opt => opt.key === selectedKey)
                console.log("selectkey", selectedOption)

                if (selectedOption && selectedOption.children && selectedOption.children.length > 0) {
                    // 添加下一级
                    levels.push({
                        options: selectedOption.children,
                        title: selectedOption.children[0]?.propertyName
                    })
                    currentOptions = selectedOption.children
                } else {
                    // 没有子选项，停止添加
                    break
                }
            }

            return levels
        }
    },
    methods: {
        // 处理选择事件（参考组件的逻辑）
        onClickCascadeItem(val, levelIndex) {
            console.log("选择", val, levelIndex)
            const currentValue = this.modelValue || []
            console.log("选择2", currentValue)
            const newValue = [...currentValue]
            console.log("选择3", newValue)
            // 如果选择了新的值，清除后续级别的选择
            newValue.splice(levelIndex, newValue.length - levelIndex, val)

            this.modelValue = newValue

            // 为符合必填校验逻辑 当所有层级都选择了 再修改父级数据 否则父级改为空
            if (newValue.length === this.cascadeLevels.length) {
                this.$emit('input', newValue)
            } else {
                this.$emit('input', null)
            }
        }
    },
    mounted() {
        this.modelValue = this.value
    }
}
